<template>
  <div class="maskEvaluation">
      <!--<im-top></im-top>-->
      <div class="evaluationMask" >
            <div class="boom">
                <div class="top" :style="{backgroundColor:boxBodyColor}">您好，您对本次服务满意吗？<a href="javascript:;" class="close"><span @click="returnMask">×</span></a></div>
                <div class="inner">
                    <div v-for="(item,index) in evaluationArr1" :key="index" class="star_box" >
                        <img :src="imgUrl+'im_star'+(index+1)+item.starImg" :alt="item" @click="mouseClick(index)" class="starImg">
                        <div>{{item.text}}</div>
                    </div>
                </div>
                <div class="inner2" v-if="satisfyMode === 2 && basicLevel != 3 && basicLevel != null" >
                    <div v-for="(objItem,objIndex) in evaluationArr2" :key="objIndex" class="star_box2" >
                        <span class="name">{{objItem.name}}</span>
                        <span v-for="(item,index) in objItem.starImg" :key="index" class="star" @click="mouseClick2(objIndex,index)">
                            <img :src="imgUrl+'im_star'+item" alt="星" >
                        </span>
                    </div>
                </div>
                <div class="inner3" v-if="satisfyMode === 2 && basicLevel != 3 && basicLevel != null" >
                    <span class="text">说明</span>
                    <div class="text_area">
                        <el-input type='textarea' :rows='3' placeholder='您的建议就是我们奋斗的目标' v-model="textarea" resize="none"></el-input>
                    </div>
                </div>
                <div class="bottom">
                    <a href="javascript:;" class="chooseTrue chooseBtn" @click="returnMask">取消</a>
                    <a href="javascript:;" class="chooseFalse chooseBtn" :style="{backgroundColor: boxBodyColor}" @click="submit">确定</a>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
//import imTop from '../imTop/IMTop.vue'
import {mapGetters} from 'vuex'
import {Message} from 'element-ui'
export default {
//   components:{
//     imTop
//   },
  data () {
    return {
      imgUrl:"/pc/static/assets/",
      evaluationArr1:[{ text:'不满意', starImg:"_dark.png",number:3},{text:'一般',starImg:"_dark.png", number:2},{text:'满意',starImg:"_dark.png",number:1}],
      evaluationArr2:[
          {name:'处理结果',starImg:['_bright.png','_bright.png','_bright.png','_bright.png','_bright.png'],num:5},
          {name:'服务态度',starImg:['_bright.png','_bright.png','_bright.png','_bright.png','_bright.png'],num:5},
          {name:'处理时长',starImg:['_bright.png','_bright.png','_bright.png','_bright.png','_bright.png'],num:5}          
      ],
      textarea: '',
      basicLevel:null,
      processAttitudeScore: 5,
      processDurationScore: 5,
      processResultScore: 5,
      boxBodyColor:'',
    }
  },
  computed: {
      ...mapGetters({
        satisfyMode: 'satisfyMode',
        showSatisfySettingFlag:'showSatisfySettingFlag'
      }),
  },
  mounted(){
    this.boxBodyColor = sessionStorage.getItem('boxBodyColor');
  },
  methods:{
      
      mouseClick (index) {
            this.basicLevel  = index + 1;
            console.log(this.basicLevel,"level");
            if(index===0)
                this.evaluationArr1 = [{text:'不满意',starImg:"_bright.png"},{text:'一般',starImg:"_dark.png"},{ text:'满意', starImg:"_dark.png"}]
            else if(index===1)
                this.evaluationArr1 = [{text:'不满意',starImg:"_dark.png"},{text:'一般',starImg:"_bright.png"},{ text:'满意', starImg:"_dark.png"}]
            else if(index===2)
                this.evaluationArr1 = [{text:'不满意',starImg:"_dark.png"},{text:'一般',starImg:"_dark.png"},{ text:'满意', starImg:"_bright.png"}]
      },
      mouseClick2 (objIndex,imgIndex) {
          var data = this.evaluationArr2;
          data[objIndex].num = imgIndex+1;
          data[objIndex].starImg = ['_dark.png','_dark.png','_dark.png','_dark.png','_dark.png'];
          data[objIndex].starImg.forEach((item,index) => {
              if(index <= imgIndex){
                  data[objIndex].starImg.splice(index,1,'_bright.png');
              }
          });
          this.$set(this.evaluationArr2,objIndex,data[objIndex]);
          // 统一data
          this.processResultScore = data[0].num;
          this.processAttitudeScore = data[1].num;
          this.processDurationScore = data[2].num;
          
      },
      returnMask () {
        this.$store.commit("setShowSatisfySettingFlag", false);
        this.$store.commit("setSatisfySetting", null);
        
      },
      submit () {
        console.log(this.satisfyMode);
        if(this.satisfyMode ===1) {
            var form = {
                basicLevel: this.basicLevel,
                comment: "",
                mode: this.satisfyMode,
                processAttitudeScore: this.processAttitudeScore,
                processDurationScore: this.processDurationScore,
                processResultScore: this.processResultScore
            }
        }else{
            if(this.basicLevel===3){
                var form = {
                    basicLevel: this.basicLevel,
                    comment: "",
                    mode: this.satisfyMode,
                    processAttitudeScore: this.processAttitudeScore,
                    processDurationScore: this.processDurationScore,
                    processResultScore: this.processResultScore
                }
            }else{
                var form = {
                    basicLevel: this.basicLevel,
                    comment: this.textarea,
                    mode: this.satisfyMode,
                    processAttitudeScore: this.processAttitudeScore,
                    processDurationScore: this.processDurationScore,
                    processResultScore: this.processResultScore
                }
            }
            
        }
        
       // console.log(form,"确认提交");
       if(this.textarea.length>50 && this.basicLevel != 3){
            Message({showClose: true, message: '说明不能超过50个字', type: 'warning'});
            return
       }else if (this.basicLevel === null){
           Message({showClose: true, message: '请对我们的服务做出评价哟！', type: 'warning'});
            return
       }
        this.$store.dispatch({
            type:'evaluate',
            visitorMd5Code: sessionStorage.md5,
            form: form
        })
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped >
    .evaluationMask{
        position: fixed;
        background-color: rgba(0,0,0,0.5);
        z-index: 1000;
        width: 640px;
        height: 620px;
        display: flex;
        justify-content: center;
        align-items: center;  
    }
    .evaluationMask .boom{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);

        min-height: 150px;
        width: 320px;
        background-color: #ffffff;
        border-radius: 2px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.3);
        box-sizing: border-box;
        /*border: 1px solid #CCCCCC;*/
        font-size: 14px;
        color: #99a0a6;
    }
    .evaluationMask .top{
        height: 40px;
        /*background: #009688;*/
        line-height: 40px;
        color: #ffffff;
        text-align: center; 
    }  
    .evaluationMask .top .close{
        position: absolute;
        right: 10px;
        vertical-align: middle;
        font-size: 26px;
        padding-left: 10px;
        text-decoration:none;
        color: #ffffff;
    }
    .evaluationMask .inner{
        padding:0 62px;
        min-height: 70px;
        /*line-height: 50px;*/
        /*border-bottom: 1px solid #CCCCCC;*/
    }
    .evaluationMask .inner{
        display: flex;
        /*align-items: center;*/
        justify-content: space-around;
        
    }
    
    .evaluationMask .inner .star_box{
        display: inline-block;
        margin-top: 10px;
        width: 50px;
        text-align: center;
        /*font-size: 12px*/
    }
    .evaluationMask .inner .star_box .starImg{
        cursor: pointer;
    }
    .evaluationMask .inner2{
        /*padding:0 28px;*/
        min-height: 70px;
        
    }
    .evaluationMask .inner2 .star{
        cursor: pointer;
    }
    .evaluationMask .inner2 .star_box2{
        padding: 0 20px 10px 20px;
        display: flex;
        justify-content: space-around;
    }
    .evaluationMask .inner3 {
        /*padding: 0 20px 10px 50px;*/
        position: relative;
    }
    .evaluationMask .inner3 .text {
        display: inline-block;
        margin: 0 20px 0 60px; 
        position: absolute;
        top: 10px;
        left: 0;

    }
    .evaluationMask .inner3 .text_area{
        display: inline-block;
        margin-left: 110px;
        width: 180px;
        height: 90px;
    }
    .evaluationMask .bottom {
        border-top: 1px solid #CCCCCC;
    }
    
    .evaluationMask .bottom .chooseBtn{
        text-decoration: none;
        display: inline-block;
        width: 70px;
        height: 25px;
        line-height: 25px;
        border-radius: 6px;
    }
    .evaluationMask .bottom .chooseTrue{
        margin: 10px 46px 10px 65px;
        text-align: center;
        color: #ffffff;
        background: #009688;
    }
    .evaluationMask .bottom .chooseFalse{
        color:#000;
        text-align: center;
        border: 1px solid #CCCCCC;
    }
</style>


// WEBPACK FOOTER //
// src/components/maskEvaluation/maskEvaluation.vue?08b1acb4